import { SearchIndex } from 'algoliasearch';
import { getAlgoliaIndex } from 'utils/search';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

// Unfortunately algoliasearch doesn't currently export the types we need
// https://github.com/algolia/algoliasearch-client-javascript/issues/1080
type AlgoliaRequestOptions = {
  attributesToRetrieve: string[];
  filters?: string;
  hitsPerPage?: number;
};

const indexes: Record<string, SearchIndex> = {};

const getIndex = (indexId: string): SearchIndex => {
  if (indexes[indexId]) {
    return indexes[indexId];
  }

  const index = getAlgoliaIndex(indexId, LanguageRegionCode.English);
  indexes[indexId] = index;
  return index;
};

const search = <TObject>(indexId: string, query: string, options: AlgoliaRequestOptions) => getIndex(indexId).search<TObject>(query, options);

export { AlgoliaRequestOptions, search };
